import {
  BottomSheetComponent,
  Modal,
  registerBottomSheets,
  registerNavigationHandlers,
} from '@bonanza-social/navigation';
import BiometricLogin from './bottomsheets/BiometricLogin/BiometricLogin';
import TermsAndConditions from './bottomsheets/TermsAndConditions/TermsAndConditions';
import { AuthNavigatorParamsList } from './AuthNavigator/AuthNavigator.types';

const bottomSheets = {
  BiometricLogin,
  TermsAndConditions,
};

registerBottomSheets('auth', bottomSheets);

declare global {
  interface RegisteredBottomSheets {
    auth: Record<keyof typeof bottomSheets, BottomSheetComponent>;
  }
}

registerNavigationHandlers<
  AuthNavigatorParamsList,
  'LoginScreen' | 'RegistrationScreen' | 'ContactUsScreen'
>({
  RegistrationScreen(navigate) {
    navigate('/register');
  },
  LoginScreen() {
    Modal.open({
      namespace: 'auth',
      type: 'Auth',
      options: {
        hideHeader: true,
      },
      style: {
        width: {
          mobile: '100%',
          tablet: '100%',
          desktop: 550,
        },
        height: {
          mobile: '100%',
          tablet: '100%',
          desktop: 800,
        },
        paddingTop: 'space-200',
        backgroundColor: 'screenBackground',
      },
    });
  },
  ContactUsScreen(navigate) {
    navigate('/contact');
  },
});

registerNavigationHandlers<AppNavigatorParamsList, 'ChangePasswordScreen'>({
  ChangePasswordScreen() {
    Modal.open({
      namespace: 'auth',
      type: 'ChangePassword',
      style: {
        width: {
          mobile: '100%',
          tablet: '100%',
          desktop: 550,
        },
        height: {
          mobile: '100%',
          tablet: '100%',
          desktop: 800,
        },
      },
    });
  },
});
